import React, { useEffect, useMemo } from "react";
import { useLayout } from "./LayoutContext";
import BgImage from "../assets/edencare-bg.png";
import { useNavigate } from "react-router-dom";

const EdencareGetStarted: React.FC = () => {
    const { setLayoutData } = useLayout();
    const navigate = useNavigate();
    const rawClient = localStorage.getItem("clientDetails");
    const clientDetails = useMemo(() => {
        const rawClient = localStorage.getItem("clientDetails");
        return rawClient ? JSON.parse(rawClient) : null;
    }, []);

    useEffect(() => {
        if (clientDetails) {
            setLayoutData({
                clientLogo: clientDetails?.brand_image,
                clientName: clientDetails?.client_name,
            });
        }
    }, [clientDetails, navigate]);

    return (
        <div className="min-h-screen px-[5px] py-4 sm:px-6 lg:px-8">
            {/* Header */}
            <div className="text-center mb-4 sm:mb-4">
                <h4 className="text-lg sm:text-xl font-semibold text-gray-700">Get your instant health check</h4>
            </div>

            {/* Progress Container */}
            <div className="flex items-center justify-center space-x-4 mb-4 sm:mb-4">
                <span className="bg-eden-primary text-white w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full text-sm sm:text-base font-medium">1</span>
                <span className="bg-gray-200 text-gray-600 w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full text-sm sm:text-base font-medium">2</span>
            </div>

            {/* Main Content */}
            <div className="w-full mx-auto bg-white p-6 sm:p-2 rounded-lg shadow-lg">
                <div className="flex flex-col lg:flex-row items-center gap-4">
                    {/* Image Section */}
                    <div className="flex-1 flex justify-center mb-4">
                        <img
                            src={BgImage}
                            alt="Facial Health Scan"
                            className="w-full max-w-sm sm:max-w-md lg:max-w-lg object-cover rounded-lg shadow-lg"
                        />
                    </div>
                    {/* Features Section */}
                    <div className="flex-1 space-y-6 sm:space-y-8">
                        {/* Feature 1 */}
                        <div className="flex items-start space-x-4 border border-gray-300 p-4 rounded-lg">
                            <div className="bg-blue-100 p-2 rounded-lg flex-shrink-0 mt-1">
                                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-600 text-lg sm:text-xl mb-2">Quick & Easy</h3>
                                <p className="text-gray-500 text-xs sm:text-base">
                                    Complete your health scan in under 2 minutes
                                </p>
                            </div>
                        </div>

                        {/* Feature 2 */}
                        <div className="flex items-start space-x-2 border border-gray-300 p-4 rounded-lg">
                            <div className="bg-green-100 p-2 rounded-lg flex-shrink-0 mt-1">
                                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-600 text-lg sm:text-xl mb-2">Secure & Private</h3>
                                <p className="text-gray-500 text-sm sm:text-base">
                                    Your data is protected and anonymized
                                </p>
                            </div>
                        </div>

                        {/* Feature 3 */}
                        <div className="flex items-start space-x-4 border border-gray-300 p-4 rounded-lg">
                            <div className="bg-purple-100 p-2 rounded-lg flex-shrink-0 mt-1">
                                <svg className="w-5 h-5 sm:w-6 sm:h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="font-semibold text-gray-600 text-lg sm:text-xl mb-2">Non-Invasive</h3>
                                <p className="text-gray-500 text-sm sm:text-base">
                                    No needles, no stress, just scan and go
                                </p>
                            </div>
                        </div>

                        {/* Get Started Button */}
                        <div className="pt-4">
                            <button className="w-full sm:w-auto bg-gradient-to-r from-eden-primary to-eden-secondary text-white font-semibold py-3 px-8 rounded-lg text-base sm:text-lg transition duration-200 ease-in-out transform hover:scale-105"
                                onClick={() => navigate('/edencare/login')}
                            >
                                Get Started
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EdencareGetStarted;